export const tr = {
    'add-turbo': 'Turbo sayfa ekle',
    'different-turbo': 'Farklı Turbo sayfalar',
    edit: 'Değiştir',
    'edit-all': 'Tümünü düzenle',
    turbo: 'Turbo sayfa'
};
